import { render, staticRenderFns } from "./editAccount.vue?vue&type=template&id=e2f4794e&scoped=true&"
import script from "./editAccount.vue?vue&type=script&lang=js&"
export * from "./editAccount.vue?vue&type=script&lang=js&"
import style0 from "./editAccount.vue?vue&type=style&index=0&id=e2f4794e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f4794e",
  null
  
)

export default component.exports